import TitleRed from "../../images/who-we-are/title-bg.svg";
import BgIcon from "../../images/gallery/bg-icon.png";
import { useQuery } from "convex/react";

function Gallery() {
  const images = useQuery("gallery:get") || [];

  return (
    <>
      <section id="gallery" className="relative min450:hidden">
        <img
          src={BgIcon}
          alt="bg_img"
          className="absolute top-[30px] right-0"
        />

        <div className="container page-padding py-[4rem]">
          {/* title div -- */}
          <div className="flex flex-col text-center relative items-center ">
            <p className="text-white relative z-10 text-[15px] uppercase font-bold mb-10">
              Gallery
            </p>
            <img
              src={TitleRed}
              alt="text_bg"
              className="w-[23rem] absolute -top-[10px]  "
            />

            <h2 className="text-[3.4rem] font-bold mb-4">
              Our Workplace Gallery
            </h2>
            <p className="text-[#646464] font-medium text-[15px] ">
              Our Workplace Gallery features modern office, team collaboration,
              and fun culture.
              <br /> Attracts talents and showcases company's work atmosphere.
            </p>
          </div>

          {/* gallery */}
          <div className="gallery-grid py-24 w-full h-auto relative ">
            {images.slice(0, 5).map((img, index) => (
              <div 
                key={img._id} 
                id={`item-${index}`}
                style={{ 
                  backgroundImage: `url(${img.url})`,
                  backgroundColor: "#f3f3f3",
                  backgroundSize: "cover",
                  backgroundPosition: "center"
                }}
              ></div>
            ))}
            {/* Fallback empty items if less than 5 images */}
            {images.length < 5 && Array.from({ length: 5 - images.length }).map((_, i) => (
              <div key={`empty-${i}`} id={`item-${images.length + i}`} className="bg-[#f3f3f3]"></div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default Gallery;
